
import _ from 'lodash';
import Vue from 'vue';
import {Component, Prop, Watch} from 'nuxt-property-decorator';
import FormInputText from '~/components/Form/FormInputText.vue';
import IconSearch from '~/components/Icon/IconSearch.vue';
import {Debounce} from '~/lib/util/vue-debounce-decorator';


function debounce<U, T extends (this: U, ...args: any[]) => any>(cb: T, wait: number) {
  let callable = _.debounce(cb, wait);
  return <T>(<any>callable);
}
@Component({
  components: {IconSearch, FormInputText},
})
export default class MyComponent extends Vue {
  @Prop({
    type: String,
    required: false,
    default: '',
  })
  placeholder!: string

  searchText = ''

  search(): void {
    this.$emit('search', this.searchText);
  }

  @Watch('searchText')
  @Debounce(250)
  watchSearchText(searchText: string) {
    this.search()
  }
}

// export default Vue.extend({
//   props: {
//     placeholder: {
//       type: String,
//       required: false,
//       default: '',
//     },
//   },
//   data() {
//     return {
//       searchText: '',
//     }
//   },
//   methods: {
//     search(): void {
//       console.log('search1')
//       this.$emit('search', this.searchText);
//     },
//     debounceSearch: debounce(function () {
//       this.search();
//     }, 250),
//   },
// })
